export const theme = {
  colors: {
    text: "#262626",
    textSecondary: "#505050",
    textMuted: "#999999",
    textInverse: "#FFFFFF",

    primary: "#0F5156",
    primaryDark: "#072A2C",
    primary60: "#6F979A",
    primaryBg: "#EDF8F8",

    secondary: "#673368",
    secondary50: "#B399B3",
    secondary20: "#F6EAFA",

    success: "#17754A",
    success20: "#DBF8E6",
    success05: "#F7FDF9",
    success45: "#97C1AE",
    warning: "#AF4000",
    warning20: "#FFEFCA",
    warning05: "#FFFBF3",
    warning45: "#DBA98C",
    error: "#C4142F",
    errorDark: "#A90020", // hover state for solid error/danger buttons
    error20: "#FFEAED",
    error05: "#FFFAFB",
    error45: "#E495A1",
    info: "#0E649D",
    info20: "#E0F5FF",
    info05: "#F8FCFF",
    info45: "#93B9D3",

    // ── Decorative (not actions or status) ──
    // color: text/icons · 20: background
    blue: "#415E80",
    blue20: "#DFEAFE",
    red: "#8A443D",
    red20: "#FFE1DD",
    green: "#506645",
    green20: "#E0EFD8",
    pink: "#A73C67",
    pink20: "#FFE1F0",
    orange: "#CA7826",
    orange20: "#FCD3BC",

    // ── Charts (use in this order; dark/light alternate) ──
    chart1: "#41559E",
    chart2: "#D1803C",
    chart3: "#8A4A96",
    chart4: "#55A36D",
    chart5: "#C23D4C",
    chart6: "#2CA0BA",
    chart7: "#952C5D",
    chartOther: "#8B9193", // = grey40

    // ── Grey scale – number ≈ how dark the grey is, in % ─────
    grey02: "#FBFBFB", // 1 % dark  · page background, table header
    grey05: "#EEF0F2", // 5 % dark  · row lines, dividers, neutral badges, skeletons, hover
    grey10: "#E1E5EB", // 9 % dark  · card borders, disabled buttons
    grey20: "#C8CDD0", // 18 % dark · secondary button border
    grey40: "#8B9193", // 40 % dark · input and form-control borders
    white: "#FFFFFF", // cards, tables, inputs
    black: "#000000",

    // ── Semantic aliases (use these in components) ──────────
    background: "#FBFBFB", // = grey02
    divider: "#EEF0F2", // = grey05
    border: "#E1E5EB", // = grey10
    disabled: "#E1E5EB", // = grey10 · text: textSecondary
    borderStrong: "#8B9193", // = grey40
    focus: "#0F5156", // = primary · 2px outline, 2px offset

    // ── Interaction ─────────────────────────────────────────
    hover: "#EEF0F2", // = grey05 · hover on white rows, menu items, cards
    secondaryHover: "#E1E5EB", // = grey05 · hover on elements on darker backgrounds
    selected: "#EEF9FA", // lighter variant of primaryBg · selected table rows

    // Neutral status badge (Makulerad, Exkluderad): grey05 background + textSecondary (6.5:1)
  },
  shadow: {
    cardShadow: "0px 3px 12px rgba(0, 0, 0, 0.06)",
    buttonShadow: "2px 4px 8px 4px rgba(0, 0, 0, 0.06)",
    circleButtonShadow: "0px 3px 12px rgba(0, 0, 0, 0.06)",
  },
};
